import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    apiLoading: {
      roleInfo: false,
    },
    loading: false,
    hasPhoto: false,
    photoInfo: null,
    roleInfo: {},
    authInfo: {
      modules: [],
      moduleAuthKeys: [],
      tabAuthKeys: [],
      actions: [],
      actionAuthKeys: [],
      viewAuthKeys: [],
    },
    allViews: [],
    allActions: [],
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setHasPhoto(state, action) {
      state.hasPhoto = action.payload;
    },
    setPhotoInfo(state, action) {
      state.photoInfo = action.payload;
    },
    setRoleInfo(state, action) {
      state.roleInfo = action.payload;
    },
    setAuthInfo(state, action) {
      state.authInfo = action.payload;
    },
    setAllViews(state, action) {
      state.allViews = action.payload;
    },
    setAllActions(state, action) {
      state.allActions = action.payload;
    },
  },
});

export const {
  setLoader,
  setLoading,
  setHasPhoto,
  setPhotoInfo,
  setRoleInfo,
  setAuthInfo,
  setAllViews,
  setAllActions,
} = userSlice.actions;

export default userSlice.reducer;
